import React, { useState, useEffect } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Banktransfers.scss";
import TransfersTemplate from "./TransfersTemplate";
import NewTransferTemplate from "./NewTransferTemplate";
import { useLocation } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {setFlag} from "../../features/responseSlice";

function Banktransfers() {
    const {flag} = useSelector((state) => state.transferResponse);

    const [activeButton, setActiveButton] = useState({ name: "Transfers" });
    const location = useLocation();
    const name = location.state?.name;
    const dispatch = useDispatch();

    const handleButtonClick = (event) => {
        setActiveButton({ name: event.target.innerText });
    };
    useEffect(() => {
        if (name !== undefined) {
            setActiveButton({ name: name })
        }
    }, []);

    useEffect(()=>{
        if([0, 1, 2].includes(flag)){
            dispatch(setFlag(null))
            setActiveButton({name:"Transfers"});
        }
    }, [flag]);

    const EntityRole = sessionStorage.getItem("EntityRole");

    return (
        <>
            <HeaderComponent title="Bank Transfers" />
            <div className="BanktransfersPage">
                <div className="container-fluid Banktransferscontainer">
                    <div className="row">
                        <div className="col-lg-10 col-sm-12 ">
                            <div className="top_section">
                                <button className={`navButton ${activeButton.name === "Transfers" ? "active" : ""}`} onClick={handleButtonClick}>Transfers</button>
                                {EntityRole!=="VIEWER" ? (
                                    <>
                                        <button className={`navButton ${activeButton.name === "+ New Transfer" ? "active" : ""}`} onClick={handleButtonClick}>+ New Transfer</button>
                                        {/*<button className={`navButton ${activeButton.name === "+ Bulk Transfer" ? "active" : ""}`} onClick={handleButtonClick}>+ Bulk Transfer</button>*/}
                                    </>
                                ) : (<></>)}
                            </div>

                        </div>
                        <div className="col-lg-2 col-sm-12"></div>
                    </div>
                    <div className="row">
                        {activeButton.name === "Transfers" && <TransfersTemplate setActiveButton={setActiveButton} />}
                        {EntityRole!=="VIEWER" ? (
                            <>
                                {activeButton.name === "+ New Transfer" && <NewTransferTemplate setActiveButton={setActiveButton}/>}
                                {/*{activeButton.name === "+ Bulk Transfer" && <BulkTransferTemplate setActiveButton={setActiveButton}/>}*/}
                            </>
                        ) : (<></>)}

                    </div>
                </div>
            </div>
        </>
    );
}

export default Banktransfers;